import { RedirectState, useOnboardingFlowStage, useCompanyInformation, useProducts } from '@neo.tax/shared';

export const useSredProjectsRedirect = (): RedirectState => {
  const { loading: loadingCompanyInformation } = useCompanyInformation();
  const { loading: loadingOnboardingFlowStage } = useOnboardingFlowStage();
  const { loading: loadingProducts } = useProducts();

  return {
    isLoading: loadingCompanyInformation || loadingOnboardingFlowStage || loadingProducts,
  };
};
